import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { FormControl, FormGroup, Validators } from '@angular/forms';

import { CANDIDATE_DETAIL_UI, VERIFY_UI } from './../../constants/ui-strings';
import { TestService } from 'src/app/services/test.service';
import { AddCandidateDetailBody } from 'src/app/model/add-candidate';
import { MessageService } from 'primeng/api';
import { TOAST_CONFIGURATION } from 'src/app/constants/constants';

@Component({
  selector: 'app-candidate-detail',
  templateUrl: './candidate-detail.component.html',
  styleUrl: './candidate-detail.component.scss'
})
export class CandidateDetailComponent {
  uploadedFileName: string = '';
  fileErrorMessage: string = '';
  candidateFormUIString = VERIFY_UI;
  candidateDetailUIString = CANDIDATE_DETAIL_UI;
  isLoading: boolean = false;
  base64DataUrl: string = '';
  browserId: string;
  candidateDetailsForm: FormGroup = new FormGroup({
    name: new FormControl({ value: this.testService.testData().name, disabled: true}, [Validators.required]),
    mobile: new FormControl({ value: this.testService.testData()?.phone, disabled: true},[Validators.required,Validators.pattern(/^[6-9]\d{9}$/)]),
    cgpa: new FormControl('',[Validators.required, Validators.pattern(/^(10|[0-9](\.[0-9])?)$/) ]),
    resume: new FormControl('',[Validators.required])
  });
  

  constructor (
    private router: Router,
    private testService: TestService,
    private messageService: MessageService,
  ) {}

  uploadResume(event: Event): void {
    const target = event.target as HTMLInputElement;
    const file = target.files?.[0];
    
    if (file) {
      if (file.type !== 'application/pdf') {
        this.candidateDetailsForm.get('resume')?.setErrors({ invalidType: true });
        this.fileErrorMessage = this.candidateDetailUIString.error_message.resume_invalid_type;
        return;
      }
      
      const maxSize = 1 * 1024 * 1024;
      if (file.size > maxSize) {
        this.candidateDetailsForm.get('resume')?.setErrors({ invalidSize: true });
        this.fileErrorMessage = this.candidateDetailUIString.error_message.resume_too_large;
        return;
      }
      this.uploadedFileName = file.name;
      const reader = new FileReader();

      reader.onload = () => {
        this.base64DataUrl = reader.result as string;
      };

      reader.readAsDataURL(file);
      
      this.candidateDetailsForm.get('resume')?.setValue(file);
      this.candidateDetailsForm.get('resume')?.markAsTouched();
      this.candidateDetailsForm.get('resume')?.setErrors(null);
    } else {
      this.fileErrorMessage = this.candidateDetailUIString.error_message.resume_invalid;
    }
  }

  removeFile(): void {
    this.uploadedFileName = '';
    this.candidateDetailsForm.get('resume')?.setValue(null);
    this.candidateDetailsForm.get('resume')?.markAsTouched();
    const fileInput = document.querySelector('input[type="file"]') as HTMLInputElement;
    if (fileInput) {
      fileInput.value = '';
    }
  }
  
  saveAndNext(): void {
    if (this.candidateDetailsForm.invalid) {
      return;
    }
    this.testService.goFullscreen(true).catch(() => {
      // Error already handled in service
    });
    const candidateDetail: AddCandidateDetailBody = {
      GPA: this.candidateDetailsForm.get('cgpa').value,
      COLLEGE_NAME: '',
      FILE: this.base64DataUrl
    }
    this.isLoading = true;
    this.testService.addCandidateDetail(candidateDetail).subscribe({
      next: (res) => {
        if (res.success) {
          this.messageService.add({
            severity: TOAST_CONFIGURATION.success,
            detail: res.message,
            closable: true
          })
          this.router.navigate(['/']);
        } else {
          this.messageService.add({
            severity: TOAST_CONFIGURATION.warning,
            detail: res.message,
            closable: true
          })
        }
        this.isLoading = false;
      },
      error: (err) => {
        this.messageService.add({
          severity: TOAST_CONFIGURATION.failed,
          summary: err.status,
          detail: err.message,
          closable: true
        })
        this.isLoading = false;
      }
    })
  }
}
